<script lang="ts">
    import type { InteractiveTitleStaticStringDefinition } from '../../types';

    interface Props {
        field: InteractiveTitleStaticStringDefinition;
    }
    let { field }: Props = $props();
</script>

{field.value}
